module.exports = __webpack_public_path__ + "img/loginZoomFromProfile.b4e3b09e.png";